import { handleCreateUser, handleDeleteUser, handleEditUser } from 'serviceWorker/services/users';
import { userSource } from 'serviceWorker/services/users/userSource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { userContract } from 'shared/domain/user/userContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the user requests: one user for its details view, and changes,
 * answered once queued (the outcome follows as an event with their `uniqueId`).
 */
export function serveUserRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(userContract, userSource),
    channelServer.handle(userContract, {
      getOneById: ({ id }) => userSource.getOneById(id),
      create: handleCreateUser,
      edit: handleEditUser,
      remove: handleDeleteUser,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
